import React from 'react';
import UserActivityContext from './context';

const UserActivityConsumer = ({children, ...props}) => {
    return (
        <UserActivityContext.Consumer>
            {(getUserActivityData) => {
                const {completed, data, loading} = getUserActivityData();
                return React.cloneElement(children, {
                    ...props,
                    userActivityCompleted: completed,
                    userActivityData: data,
                    userActivityLoading: loading,
                });
            }}
        </UserActivityContext.Consumer>
    );
};

export default UserActivityConsumer;
